import { Result } from './serpApi';
import { SavedLead } from './leadsService';

// Define os tipos de dados que podem ser exportados
type ExportableData = Result | SavedLead;

/**
 * Converte um array de objetos em uma string CSV.
 * @param data Array de objetos (Result ou SavedLead).
 * @param filename Nome do arquivo de saída.
 */
export function exportToCsv(data: ExportableData[], filename: string = 'export_leads.csv'): void {
  if (data.length === 0) {
    console.warn('Nenhum dado para exportar.');
    return;
  }

  // 1. Determinar os cabeçalhos (Headers)
  // Usamos um conjunto fixo de chaves para garantir a ordem e consistência
  const headers = [
    'company_name', 'phone_number', 'email', 'website', 'address', 
    'category', 'whatsapp_status', 'rating', 'prospected', 'external_id', 'created_at'
  ];

  // 2. Mapear os dados para linhas CSV
  const csvRows = [];
  
  // Adiciona o cabeçalho
  csvRows.push(headers.join(';'));

  // Adiciona as linhas de dados
  for (const item of data) {
    const values = headers.map(header => {
      let value: any;
      
      // Mapeamento de campos para unificar Result e SavedLead
      if ('empresa' in item) { // É um Result (Dashboard)
        switch (header) {
          case 'company_name': value = item.empresa; break;
          case 'phone_number': value = item.phone || item.contato; break;
          case 'address': value = item.localizacao; break;
          case 'whatsapp_status': value = item.status; break;
          case 'website': value = item.website; break;
          case 'rating': value = item.rating; break;
          case 'prospected': value = item.prospected ? 'Sim' : 'Não'; break;
          case 'external_id': value = item.place_id; break;
          default: value = '';
        }
      } else { // É um SavedLead (Leads Salvos)
        value = (item as any)[header];
        if (header === 'prospected') {
            value = item.prospected ? 'Sim' : 'Não';
        }
      }
      
      // Limpeza e formatação do valor
      if (value === null || value === undefined) {
        value = '';
      } else if (typeof value === 'string') {
        // Remove quebras de linha e aspas duplas, e envolve em aspas se contiver ponto e vírgula
        value = value.replace(/"/g, '""').replace(/\n/g, ' ');
        if (value.includes(';')) {
          value = `"${value}"`;
        }
      }
      
      return value;
    });
    csvRows.push(values.join(';'));
  }

  // 3. Criar o Blob e o link de download
  const csvString = csvRows.join('\n');
  
  // Adiciona o Byte Order Mark (BOM) para UTF-8 para garantir que caracteres especiais funcionem no Excel
  const BOM = "\uFEFF"; 
  const finalCsvString = BOM + csvString;
  
  // Usamos 'text/csv;charset=utf-8;' no tipo do Blob
  const blob = new Blob([finalCsvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) { // Verifica se o navegador suporta o atributo download
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // Fallback para navegadores mais antigos
    window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
  }
}